import SafeImage from '@ui/SafeImage';
import Link from 'next/link';
import { ShopTireItem } from '../data/acessories';

export const ShopTireCard = ({
  image,
  name,
  description,
  url,
}: ShopTireItem & { url: string }) => {
  return (
    <div className="relative h-[46rem] w-[49rem] overflow-hidden rounded-[0.5rem] bg-white">
      <SafeImage
        src={image}
        alt="template-tire"
        width={1920}
        height={2560}
        className={`h-[32rem] w-full object-cover`}
      />

      <div className="flex flex-col gap-y-6 px-8">
        <span className="text-[2.5rem] font-semibold">{name}</span>
      </div>

      <div className="mt-8 h-[0.5rem] w-full bg-[#F6F6F6]" />

      <div className="flex h-[8rem] flex-col items-center gap-y-6 px-8">
        <div className="flex h-full w-full items-center justify-between">
          <span className="max-w-[32rem] text-[1.5rem] font-medium text-[#444444]">
            {description}
          </span>

          <Link
            href={url}
            target="_blank"
            className="rounded-full bg-brand-secondary px-8 py-4 text-[1.5rem] font-semibold text-white"
          >
            Shop Now
          </Link>
        </div>
      </div>
    </div>
  );
};
